export const ResolutionButtonsEnum = {
  Home: { width: "100%", height: "90vh" },
  StayCurrentPortrait: { width: "480px", height: "90vh" },
  Tablet: { width: "1024px", height: "90vh" },
  Computer: { width: "1600px", height: "90vh" },
}

export default ResolutionButtonsEnum;